import { ATTACHMENT_TYPES } from '../../constants/settings.constants';
import { TEMPLATE_CATEGORIES_SUFFIXES } from '../../constants/templates.constants';
import DossierTemplates from '../../containers/dossier-templates/DossierTemplates';
import { useAttachmentCRUD } from '../../hooks/useAttachmentCRUD.hook';
import { getAttachmentsForProcedure } from '../../lib/dossier.utils';
import { getTemplateCategory } from '../../lib/template.utils';
import AttachmentDetailsModal from '../../modals/AttachmentDetailsModal';
import AttachmentUploadModal from '../../modals/AttachmentUploadModal';
import DeleteWarningModal from '../../modals/DeleteWarningModal';
import AttachmentsList from '../attachments/AttachmentsList';

const DossierProcedureAttachments = ({
  dossierId,
  dossierType,
  attachments,
  isLoadingAttachments,
  onAttachmentsRefetch,
  write
}) => {
  const attachmentCRUD = useAttachmentCRUD(dossierId);

  return (
    <>
      <AttachmentsList
        loading={isLoadingAttachments}
        attachments={getAttachmentsForProcedure(attachments)}
        title="Bestanden"
        onUpload={write ? () => attachmentCRUD.onAttachmentAddOpen(undefined, ATTACHMENT_TYPES.PROCEDURE) : undefined}
        onOpen={attachmentCRUD.onAttachmentOpen}
        templates={
          write && (
            <DossierTemplates category={getTemplateCategory(dossierType, TEMPLATE_CATEGORIES_SUFFIXES.PROCEDURE)} />
          )
        }
      />
      <AttachmentUploadModal {...attachmentCRUD.uploadModal} onConfirm={attachmentCRUD.onAttachmentAdd} />
      <AttachmentDetailsModal
        {...attachmentCRUD.detailsModal}
        write={write}
        form={attachmentCRUD.attachmentDetailForm}
        dossierId={dossierId}
        onUpdate={attachmentCRUD.onAttachmentUpdate}
        onUpdateSuccess={onAttachmentsRefetch}
        onDelete={attachmentCRUD.deleteModal.onOpen}
      />
      <DeleteWarningModal
        {...attachmentCRUD.deleteModal}
        warningText="Weet je zeker dat je deze bijlage wilt verwijderen?"
        onConfirm={attachmentCRUD.onAttachmentDelete}
      />
    </>
  );
};

export default DossierProcedureAttachments;
